import { MDBIcon } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useDarkMode } from "../assets/DarkModeContext";
import { http } from "../services/httpService";

export default function CompetenceItemEdit(
    {
        item,
        categories,
        selectedLanguage,
        setEditingCompetence,
        setCompetences,
    } ) {

    const [ formData, setFormData ] = useState( {
        id: item.id,
        categoryId: item.categoryId,
        competenceFr: item?.competenceTranslations[ 'fr' ] || '',
        competenceEn: item?.competenceTranslations[ 'en' ] || '',
        descriptionFr: item?.descriptionTranslations[ 'fr' ] || '',
        descriptionEn: item?.descriptionTranslations[ 'en' ] || '',
    } );

    const { isDarkMode } = useDarkMode();

    const handleCategoryChange = ( newCategoryId ) => {
        setFormData( prev => ( {
            ...prev,
            categoryId: +newCategoryId
        } ) );
    };

    const handleEditFormChange = ( e ) => {
        setFormData( { ...formData, [ e.target.name ]: e.target.value } );
    };

    const handleEditSubmit = async ( event ) => {
        event.preventDefault();

        const competenceToUpdate = {
            id: formData.id,
            categoryId: formData.categoryId,
            competenceTranslations: {
                fr: formData.competenceFr,
                en: formData.competenceEn,
            },
            descriptionTranslations: {
                fr: formData.descriptionFr,
                en: formData.descriptionEn,
            },
        };

        try {
            const response = await http( `ref/competences/${ formData.id }`, {
                method: 'PUT',
                body: JSON.stringify( competenceToUpdate ),
            } );

            if ( !response.ok ) {
                throw new Error( `HTTP error! status: ${ response.status }` );
            }

            const updatedCompetence = await response.json();

            setCompetences( prevState => prevState.map( comp => comp.id === item.id ? updatedCompetence : comp ) );

            setEditingCompetence( null );

            toast.success( "Compétence mise à jour avec succès" );
        } catch ( error ) {
            console.error( 'Erreur pendant la mise à jour :', error );
            toast.error( "Erreur pendant la mise à jour : " + error );
        }
    };
    return (
        <>
            <tr className={ `${ isDarkMode ? 'text-white' : '' }` }>
                <td rowSpan={ 2 }>
                    <p>
                        <label htmlFor="categoryId">Catégorie:</label>
                        <select
                            id="categoryId"
                            name="categoryId"
                            value={ formData.categoryId || 0 }
                            onChange={ ( e ) => handleCategoryChange( e.target.value ) }
                        >
                            { categories
                                .sort( ( a, b ) =>
                                    a.translations[ selectedLanguage ]
                                        .localeCompare( b.translations[ selectedLanguage ]
                                        ) )
                                .map( ( category ) => (
                                    <option key={ category.id } value={ category.id }>
                                        { category.translations[ selectedLanguage ] }
                                    </option>
                                ) ) }
                        </select>
                    </p>
                </td>
                <td>
                    <p>
                        <label htmlFor="competenceFr"><i className="flag flag-france"></i>Nom :</label>
                        <input
                            type="text"
                            id="competenceFr"
                            name="competenceFr"
                            value={ formData.competenceFr }
                            onChange={ handleEditFormChange }
                            required
                        />
                    </p>
                </td>
                <td>
                    <p>
                        <label htmlFor="descriptionFr"><i className="flag flag-france"></i>Description :</label>
                        <textarea
                            id="descriptionFr"
                            name="descriptionFr"
                            value={ formData.descriptionFr }
                            onChange={ handleEditFormChange }
                            rows="3"
                            style={ { width: '100%' } }
                        /></p>
                </td>
                <td rowSpan={2}>
                    <MDBIcon fas icon="check-square" size='lg' className='text-success'
                             onClick={ handleEditSubmit }/>
                    <MDBIcon fas icon="window-close" className='ms-2 text-danger'
                             size='lg' onClick={ () => setEditingCompetence( null ) }/>
                </td>
            </tr>
            <tr className={ `${ isDarkMode ? 'text-white' : '' }` }>
                <td>
                    <p>
                        <label htmlFor="competenceEn"><i className="flag flag-united-kingdom"></i>Nom :</label>
                        <input
                            type="text"
                            id="competenceEn"
                            name="competenceEn"
                            value={ formData.competenceEn }
                            onChange={ handleEditFormChange }
                            required
                        />
                    </p>
                </td>
                <td>
                    <p>
                        <label htmlFor="descriptionEn"><i className="flag flag-united-kingdom"></i>Description :</label>
                        <textarea
                            id="descriptionEn"
                            name="descriptionEn"
                            value={ formData.descriptionEn }
                            onChange={ handleEditFormChange }
                            rows="3"
                            style={ { width: '100%' } }
                        /></p>
                </td>
            </tr>
        </>
    );
}